import cn from "classnames";
import s from "./CornerLabelVariant1.module.scss";

interface CornerLabelVariant1Props extends Pick<HTMLDivElement, "className"> {
  text: string;
}

export default function CornerLabelVariant1(props: CornerLabelVariant1Props) {
  const { text, className } = props;

  return <div className={cn(s.cornerLabel, className)}>{text}</div>;
}
